import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const responseSchema = yup.object({
  needToShow: yup.boolean().required(),
  bodyEmail: yup.string().nullable(),
  bodySms: yup.string().nullable(),
  subject: yup.string().required(),
  successMessage: yup.string().required(),
});

const composeResponse = (response) => {
  const data = response.data.data || {};
  return {
    needToShow: Boolean(data.send_email_status),
    bodyEmail: data.appointment_email_text,
    bodySms: data.appointment_sms,
    subject: data.appointment_subject,
    successMessage: data.success_msg,
  };
};

export function useAppointmentNoShowNotificationQuery(
  { appointmentId },
  options = {},
) {
  return useQuery(
    [QUERY_KEYS.appointments.noShowNotification, appointmentId],
    async () => {
      const res = await http.get(
        HTTP_ENDPOINTS.appointments.getNoShowNotitication(appointmentId),
      );
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
